import { configureStore } from "@reduxjs/toolkit"
import { apiSlice } from "./api/apiSlice"
import authReducer from './appSlices/auth/authSlice'
import collaboratorReducer from "./appSlices/collaborator/collaboratorSlice"
import translationReducer from "./appSlices/appTranslationSlice"

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authReducer,
        collaborator: collaboratorReducer,
        translation: translationReducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true
})